import type { FaireProductEntity } from "../../entity_types/product";

export const p_v5uj3ashbs: FaireProductEntity = {
  token: "p_v5uj3ashbs",
  type: "product",
  name: "RUE 52",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/54862c3e554981105c9955214f25253cdcf9f8081a79bb5864cc365950067ca9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/236a84b0c748967a89423cb4c5b1368efc3b2854bf1495be57cd43373981853f.jpeg",
    "https://cdn.faire.com/fastly/1f70b5ff93ab7b488c3cf5384b6c93093256c95f905e0d4d1a4fbbd78154c6ce.jpeg",
    "https://cdn.faire.com/fastly/f16c005e21eb78cb25b44648037752be8d896b7025421368271df3ddc6bce690.jpeg"
  ],
  priceDollars: 19,
  description: "Roam the streets of Paris along the Seine, where old world meets new. The rich scent of aged leather books from the street vendors layers with the aroma of exotic spices from the outdoor market. Whispers of fresh baked goods from the corner patisserie blend with the softest accent of sweet tobacco and fresh cut stems.\n\nsmoked amber, black pepper, violet absolute, aged leather, star anise\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature French box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:09.895Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
